import React from "react"
import { Column, Container, Row } from "../components/Grid"
import Hero from "../components/Hero"
import Layout from "../components/Layout"
import Resource from "../components/Resource"
import Section from "../components/Section"
import SEO from "../components/Seo"
import FooterCallout from "../partials/footerCallout"

import { Link } from "gatsby"
import Image from "../components/Image"
import lovingMeLessonExtension from "../docs/loving-me/digital-lesson.pdf"
import LovingMeTeacherGuide from "../docs/loving-me/teacher-guide.pdf"
import { lovingMe } from "../partials/classroomActivities"

const MasterClass = () => (
  <Layout>
    <SEO title="Master Class Resources" />
    {/***************  HERO ***************/}
    <Section className="hero hero__loving-me">
      <Hero
        title={
          <>
            <p className="header-bar__grade">Grades K&mdash;2</p>
            <span className={"header-bar--yellow"}>
              Loving Me Featuring Blippi
            </span>
          </>
        }
        body="Young learners explore body confidence by focusing on what their bodies can do—not how they look."
        image="img-loving-me-featuring-blippi-hero-circle.png"
      />
    </Section>

    {/***************  INTRODUCTION TEXT ***************/}
    <Section>
      <Container>
        <h2>Digital Lesson Bundle</h2>
        <p>
          Celebrate every child’s unique abilities with Blippi x Dove’s Loving
          Me resources. This buildable program celebrates what bodies can
          do—fostering kindness and self-love in every classroom.
        </p>
      </Container>
    </Section>

    {/***************  DIGITAL LESSON BUNDLE ***************/}
    <Section className="loving-me toolkit" id="loving-me">
      <Container>
        <h2>Digital Lesson Bundle</h2>
        <Row>
          <Column span={6}>
            <Resource
              image="img-blippi-loving-me-ppt.png"
              subjects={["PowerPoint"]}
              title="My Body is Amazing: Loving ME!"
              grade="Grades K&mdash;2"
              duration="3 Sessions (45 minutes each)"
              description={
                <p>
                  This joyful, movement-filled Digital Lesson Powerpoint
                  celebrates the unique abilities of our bodies. This 5-day
                  lesson experience helps young children build confidence and
                  express themselves positively through play, music, and
                  reflection. Students will focus on what their bodies can do,
                  not how they look, promoting a foundation of body confidence
                  and self-love from an early age.
                </p>
              }
              actions={[
                {
                  label: "Classroom Presentation",
                  type: "download",
                  path: "/files/DLB-LovingMe.pptx",
                  title:
                    "My Body is Amazing: Loving ME! Classroom Presentation",
                },
              ]}
            />
          </Column>
          <Column span={6}>
            <Resource
              image="img-dlb-loving-me.png"
              subjects={["PDF"]}
              title="Educator Guide"
              grade="Grades K&mdash;2"
              duration="3 Sessions (45 minutes each)"
              description={
                <p>
                  This Educator Guide is designed to enhance the Loving Me
                  Lesson Presentation by offering facilitation strategies,
                  educator guidance, and ideas for modifications. Its purpose is
                  to help primary students build body confidence by emphasizing
                  what their bodies can do rather than how they look. The guide
                  also includes student-friendly capture sheets and suggestions
                  for learning station extensions, ideal for centers or
                  small-group enrichment activities.
                </p>
              }
              actions={[
                {
                  label: "Educator Guide",
                  type: "download",
                  path: LovingMeTeacherGuide,
                  title:
                    "Educator Guide - My Body is Amazing: Loving ME! Educator Guide",
                },
                {
                  label: "Lesson Extension",
                  type: "download",
                  path: lovingMeLessonExtension,
                  title:
                    "Lesson Extension - My Body is Amazing: Loving ME! Lesson Extension",
                },
              ]}
            />
          </Column>
        </Row>
      </Container>
      <Container style={{ paddingTop: "2rem" }}>
        <Row style={{ background: "transparent" }}>
          {lovingMe.map((item, i) => (
            <Column span={4} key={i}>
              <Resource label="READY-TO-USE ACTIVITY" {...item} inGrid />
            </Column>
          ))}
        </Row>
      </Container>
    </Section>

    {/***************  EXPLORE ADDITIONAL RESOURCES ***************/}
    <Section className={"squiggle"}>
      <Container>
        <h3>Explore Additional Resources</h3>
        <Row>
          <Column span={5} className={"is-offset-1 resource"}>
            <Image
              className={"resource-image"}
              filename={"img-promo-resources.png"}
              alt=""
            />
            <h4 className={"bold-text"}>Classroom Resources</h4>
            <p>
              Help your students realize their full potential with classroom
              resources.
            </p>
            <Link to={"/classroom-resources"}>Learn More</Link>
          </Column>
          <Column span={5} className={"resource"}>
            <Image
              className={"resource-image"}
              filename={"img-confident-me-add-resource.png"}
            />
            <h4 className={"bold-text"}>Confident Me Workshop</h4>
            <p>
              Help your students realize their full potential with classroom
              resources.
            </p>
            <Link to={"/confident-me-workshop/"}>Learn More</Link>
          </Column>
        </Row>
      </Container>
    </Section>

    {/***************  ABOVE FOOTER CALLOUT ***************/}
    <Section className="body-confidence-fact--loving-me">
      <Container>
        <Row>
          <Column span={7}>
            <p>
              The Dove Self-Esteem Project and Blippi, together with the Centre
              for Appearance Research, have created Blippi's Wonderful Talent
              Show, an upbeat and interactive set of edutainment videos aimed at
              building body confidence and self-esteem in the next generation of
              young people.
            </p>
          </Column>
          <Column
            span={4}
            className={"is-offset-1 body-confidence-fact__container"}
          >
            <div className={"body-confidence-fact__container__image"}>
              <Image filename={"img-subfooter-8.png"} className={""} />
            </div>
          </Column>
        </Row>
      </Container>
    </Section>

    {/***************  FOOTER CALLOUT ***************/}
    <FooterCallout />
  </Layout>
)

export default MasterClass
